export default __webpack_public_path__ + "static/media/angle-small-left.b653abc9.svg";